import { Injectable } from "@angular/core";
import { Page, Tiers, TiersForm, Statistic, DateInterval } from '../models';
import { Observable, Subject } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable()
export class TiersService {

  tiersUrl = environment.dns + 'api/tiers/';

  tier : Tiers;

  tierselected = new Subject<Tiers>();


  emitTiers(tiers: Tiers) {
    this.tierselected.next(tiers);
    this.tier = tiers;
  }

  constructor(private http: HttpClient) { }

  getPaginate(page: number, size: number, search : String = ""): Observable<Page<Tiers>> {
    return this.http.get<Page<Tiers>>(this.tiersUrl + 'paginate?page=' + page + '&size=' + size + '&search='+search);
  }

  getListByTypes(typesTiers: String[]): Observable<Tiers[]> {
    let params = new HttpParams();
    params = params.append('types', typesTiers.join(','));
    return this.http.get<Tiers[]>(this.tiersUrl + 'list-by-types' , { params: params });
  }

  getListMinByTypes(typesTiers: String[]): Observable<Array<{id:number; name:string; typeName:string}>> {
    let params = new HttpParams();
    params = params.append('types', typesTiers.join(','));
    return this.http.get<Array<{id:number; name:string; typeName:string}>>(this.tiersUrl + 'min/by-types', { params });
  }

  getOne(id: number): Observable<Tiers> {
    return this.http.get<Tiers>(this.tiersUrl + id);
  }

  getStatistics(dateInterval: DateInterval): Observable<Statistic[]>{
    return this.http.post<Statistic[]>(this.tiersUrl + 'statistics', dateInterval);
  }

  add(tiersForm: TiersForm): Observable<Tiers> {
    return this.http.post<Tiers>(this.tiersUrl, tiersForm);
  }

  update(tierForm: TiersForm): Observable<Tiers> {
    return this.http.put<Tiers>(this.tiersUrl, tierForm);
  }

  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(this.tiersUrl + id);
  }

  getMin(types: number[], q: string, page: number, size: number): Observable<Page<{id:number,name:string,typeName?:string}>> {
    let params = new HttpParams()
      .set('q', q || '')
      .set('page', page.toString())
      .set('size', size.toString());
    if (types && types.length) {
      params = params.set('types', types.join(','));
    }
    return this.http.get<Page<{id:number,name:string,typeName?:string}>>(this.tiersUrl + 'search-min', { params });
  }

  getListMinByTypesPaged(typesTiers: string[], q: string = '', page: number = 0, size: number = 50): Observable<Page<{id:number; name:string; typeName:string}>> {
    let params = new HttpParams()
      .set('types', typesTiers.join(','))
      .set('q', q || '')
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<Page<{id:number; name:string; typeName:string}>>(this.tiersUrl + 'list-min-by-types-paged', { params });
  }

  getClientTypeBreakdown(clientTypeId: number, dateInterval: DateInterval): Observable<Statistic[]> {
    const params = new HttpParams().set('clientTypeId', String(clientTypeId));
    return this.http.post<Statistic[]>(this.tiersUrl + 'statistics/client-type-breakdown', dateInterval, { params });
  }

  getListByStatus(status: 'all' | 'active' | 'prospect' = 'all'): Observable<Tiers[]> {
    const params = new HttpParams().set('status', status);
    return this.http.get<Tiers[]>(this.tiersUrl + 'list-by-status', { params });
  }

  getListByStatusAndCommercial(status: 'all' | 'active' | 'prospect', commercialId: number): Observable<Tiers[]> {
    const params = new HttpParams()
      .set('status', status)
      .set('commercialId', String(commercialId));
    return this.http.get<Tiers[]>(this.tiersUrl + 'list-by-status-and-commercial', { params });
  }

  getListMinByStatus(status: 'all' | 'active' | 'prospect' = 'all'): Observable<Array<{id:number; name:string; typeName:string}>> {
    const params = new HttpParams().set('status', status);
    return this.http.get<Array<{id:number; name:string; typeName:string}>>(this.tiersUrl + 'list-min-by-status', { params });
  }

  getListMinByStatusPaged(status: 'all' | 'active' | 'prospect' = 'all', q: string = '', page: number = 0, size: number = 50): Observable<Page<{id:number; name:string; typeName:string}>> {
    const params = new HttpParams()
      .set('status', status)
      .set('q', q || '')
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<Page<{id:number; name:string; typeName:string}>>(this.tiersUrl + 'list-min-by-status-paged', { params });
  }

  getMapPoints(status: 'all' | 'active' | 'prospect' = 'all'): Observable<Array<{id:number; name:string; prospect:boolean; latitude:number; longitude:number; address:string; commercials:string}>> {
    const params = new HttpParams().set('status', status);
    return this.http.get<Array<{id:number; name:string; prospect:boolean; latitude:number; longitude:number; address:string; commercials:string}>>(this.tiersUrl + 'map-points', { params });
  }
}
